import request from '@/utils/request'
const apiPath = '/sys/sysDataconstant'
const sysDataconstantApi = {
  /**
   * 新增【系统常量配置表】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【系统常量配置表】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【系统常量配置表】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 按 code 查单条常量。
   * config 可传 { silent: true } —— 常量没插进库时后端抛"记录不存在"，调用方自己兜底时不弹错误提示。
   */
  fetchCode(query, config) {
    // return request.get(apiPath + '/listV2', { params: query })
    return request.get(apiPath + '/showByCode', { params: query, ...config })
  },
  fetchBatchCode(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  /**
   * 查看【系统常量配置表】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【系统常量配置表】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
}
export default sysDataconstantApi
